import { render, staticRenderFns } from "./ShainToroku.vue?vue&type=template&id=49ac3142&scoped=true"
import script from "./ShainToroku.vue?vue&type=script&lang=js"
export * from "./ShainToroku.vue?vue&type=script&lang=js"
import style0 from "./ShainToroku.vue?vue&type=style&index=0&id=49ac3142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac3142",
  null
  
)

export default component.exports